import { DocumentPage } from '@/components/DocumentPage'
import styles from './PrivacyPage.module.css'

/**
 * Privacy Policy (EU/GDPR). Разметка-скелет: финальный юридический текст
 * предоставляет заказчик. Прежний РФ-контент (152-ФЗ, реквизиты ИП) удалён.
 */
const SECTIONS: { heading: string; body: string }[] = [
  {
    heading: '1. Introduction',
    body: 'This Privacy Policy explains how we collect, use and protect your personal data when you use our website and online courses. [Final text to be provided.]',
  },
  {
    heading: '2. Data controller',
    body: 'The data controller responsible for your personal data is [company name, address, registration number]. [To be provided.]',
  },
  {
    heading: '3. Data we collect',
    body: 'We may collect: account data (name, email), purchase data, and technical data (IP address, device and browser type, cookies).',
  },
  {
    heading: '4. How we use your data',
    body: 'To provide access to courses, process purchases, operate and secure the service, and — with your consent — send you updates.',
  },
  {
    heading: '5. Legal basis (GDPR)',
    body: 'We process data on the basis of contract performance, legitimate interest, legal obligation, and your consent, as applicable.',
  },
  {
    heading: '6. Cookies',
    body: 'We use essential cookies to run the site and, with your consent, optional cookies to improve it. You manage your choice via the cookie banner.',
  },
  {
    heading: '7. Data sharing',
    body: 'We share data only with processors needed to run the service (e.g. payment and hosting providers), under appropriate agreements.',
  },
  {
    heading: '8. Data retention',
    body: 'We keep your data only as long as necessary for the purposes above or as required by law.',
  },
  {
    heading: '9. Your rights',
    body: 'Under the GDPR you have the right to access, rectify, erase, restrict and port your data, to object to processing, and to withdraw consent at any time.',
  },
  {
    heading: '10. International transfers',
    body: 'Where data is transferred outside the EEA, we apply appropriate safeguards. [To be provided.]',
  },
  {
    heading: '11. Contact',
    body: 'For privacy requests contact us at [email]. You also have the right to lodge a complaint with your local data protection authority.',
  },
]

export const PrivacyPage = () => (
  <DocumentPage title="Privacy Policy">
    <p className={styles.paragraph}>
      <em>This is a working draft. The final legal text will be provided.</em>
    </p>
    {SECTIONS.map(section => (
      <section key={section.heading} className={styles.section}>
        <h2 className={styles.sectionTitle}>{section.heading}</h2>
        <p className={styles.paragraph}>{section.body}</p>
      </section>
    ))}
  </DocumentPage>
)

export default PrivacyPage
